var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"paper-download-button"},[_c('a',{attrs:{"target":"_blank","href":_vm.url,"no-work-wechat":""},on:{"click":_vm.handleClick}},[_vm._v("下载高清试卷")]),_c('span',{staticClass:"tips"},[_vm._v("有答案解析")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }